// extracted by mini-css-extract-plugin
export default {"BirthDateInput":"bfs_a bib_z bib_kc bib_qx bib_xc bib_eg","BirthDateInput--disabled":"bfs_b bib_fo"};